/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * (german: Einstufungsgrund für Schadensfreiheitsklasse)   (bipro-datentypen::SFEinstufungsgrund)     * `None`                  - german: kein Einstufungsgrund   * `WithPreviousContract`  - german: mit Vorvertrag   * `NoPreviousContract`    - german: kein Vorvertrag   * `FirstInsurance`        - german: Erstvertrag   * `SecondVehicle`         - german: Zweitfahrzeug   * `Spouse`                - german: Ehegatte   * `CompanyCar`            - german: Dienstwagen   * `CarSharing`            - german: Car Sharing
 */
export const NcdClassReason = {
  None: 'None',
  WithPreviousContract: 'WithPreviousContract',
  NoPreviousContract: 'NoPreviousContract',
  FirstInsurance: 'FirstInsurance',
  SecondVehicle: 'SecondVehicle',
  Spouse: 'Spouse',
  CompanyCar: 'CompanyCar',
  CarSharing: 'CarSharing',
} as const;
export type NcdClassReason = (typeof NcdClassReason)[keyof typeof NcdClassReason];
